import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { SharedService } from '../../../shared-components/shared.service';
import { Year } from '../../../shared-components/year/year.model';
import { YearService } from '../../../shared-components/year/year.service';
import { FreeReducedMealAppService } from '../../../shared-modules/free-reduced-meal-app/free-reduced-meal-app.service';
import { FreeReducedMealAppComponent } from '../../../shared-modules/free-reduced-meal-app/free-reduced-meal-app/free-reduced-meal-app.component';
import { FreeReducedMealAppFamily } from '../../../shared-modules/free-reduced-meal-app/models/free-reduced-meal-app-family.model';
import { FreeReducedMealApp } from '../../../shared-modules/free-reduced-meal-app/models/free-reduced-meal-app.model';
import * as moment from 'moment';
import { System } from '../../../shared-components/System';
import { FreeReducedMealAppStudentStatusComponent } from '../free-reduced-meal-app-student-status/free-reduced-meal-app-student-status.component';
import { orderBy } from 'lodash';
import { FrmaUnsubmittedAppDialogComponent } from '../frma-unsubmitted-app-dialog/frma-unsubmitted-app-dialog.component';
import { ParentStudentPortalSettingsService } from '../../../management360/district/parent-student-portal-settings/parent-student-portal-settings.service';
import { FreeReducedMealAppYearSelectorComponent } from '../free-reduced-meal-app-year-selector/free-reduced-meal-app-year-selector.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { StudentService } from '../../../shared-components/student/student.service';

@Component({
  selector: 'app-free-reduced-meal-app-summary',
  templateUrl: './free-reduced-meal-app-summary.component.html',
  styleUrls: ['./free-reduced-meal-app-summary.component.css']
})
export class FreeReducedMealAppSummaryComponent implements OnInit {

  dataSource = new TylerMatTableDataSource();
  years: Year[];
  yearId: number;
  showGrid = false;
  showNoAppsMessage = false;
  showCurrentStatusMessage = false;
  selectedFamily: FreeReducedMealAppFamily;
  applications: FreeReducedMealApp[] = [];
  disableAdd = false;
  yearChanged = false;

  @ViewChild(FreeReducedMealAppStudentStatusComponent) studentLunchStatus: FreeReducedMealAppStudentStatusComponent;
  familyWarningShown: any;
  dialogRef: any;
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.dataSource.sort = value;
  }

  constructor(
    private dialog: MatDialog,
    private freeReducedMealAppService: FreeReducedMealAppService,
    private studentService: StudentService,
    private yearService: YearService,
    private sharedService: SharedService,
    private translateService: TranslateService,
    private parentStudentPortalSettingsService: ParentStudentPortalSettingsService
  ) { }

  ngOnInit(): void {
    this.selectedFamily = this.freeReducedMealAppService.selectedFamily;
    if (this.selectedFamily == undefined) {
      this.selectedFamily = new FreeReducedMealAppFamily();
    }
    this.yearId = this.yearService.student360Year.Id;
    this.getYears();
    this.getApplications(null);
  }

  getApplications(_callback: Function) {
    if (this.selectedFamily.UserCanSeeAllStudents) {
      this.freeReducedMealAppService.getFrmaAppsByFamilyID(this.selectedFamily.FamilyID, this.yearId).pipe(take(1)).subscribe(apps => {
        this.applications = apps;
        this.dataSource.data = apps;
        this.showCurrentStatusMessage = false;
        if (apps && apps.length > 0) {
          this.showGrid = true;
          this.showNoAppsMessage = false;
          if (apps.find(o => o.Status == 'submitted')) {
            this.showCurrentStatusMessage = true;
          }
        }
        else {
          this.showGrid = false;
          this.showNoAppsMessage = true;
        }
        if (_callback) {
          _callback();
        }
      });
    }
  }

  getFamilies(_callback: Function) {
    this.freeReducedMealAppService.getFrmaFamilies(this.yearId).pipe(take(1)).subscribe(fams => {
      this.selectedFamily = fams.find(o => o.FamilyID == this.selectedFamily.FamilyID);
      this.getApplications(_callback);
    });
  }

  getYears() {
    this.freeReducedMealAppService.getFRMAYearsForParent(this.selectedFamily.FamilyID).pipe(take(1)).subscribe(years => {
      this.years = years;
      const selectedYear = this.years.find(o => o.Id == this.yearId);
      if (selectedYear) {
        if (selectedYear.Status == 0) {
          // past year - disable add button
          this.disableAdd = true;
        }
      }
    });
    // this.years = this.yearService.allYears.filter(o => o.SchoolID == this.yearService.student360Year.SchoolID);
    // this.parentStudentPortalSettingsService.getPortalDataAreas().pipe(take(1)).subscribe(dataAreas => {
    //   const frmaSettings = dataAreas.find(o => o.Area == 'Free/Reduced Meal Application');
    //   if (frmaSettings) {
    //     this.years = this.yearService.allYears.filter(o => o.SchoolID == this.yearService.student360Year.SchoolID
    //       && (
    //         (o.Status == 0 && frmaSettings.Past)
    //         || (o.Status == 1 && frmaSettings.Current)
    //         || (o.Status == 2 && frmaSettings.Future)
    //       )
    //     );
    //   }
    // });
  }

  editClick(app: FreeReducedMealApp) {
    this.freeReducedMealAppService.getFrmaApplication(app.ID).pipe(take(1)).subscribe(a => {
      const selectedYear = this.years.find(o => o.Id == this.yearId);
      const dialogRef = this.dialog.open(FreeReducedMealAppComponent, {
        height: '100vh',
        maxHeight: '100vh',
        width: '1000px',
        disableClose: true,
        data: {
          isDesignMode: false,
          singlePageMode: false,
          appData: a,
          selectedYear: selectedYear
        }
      });

      dialogRef.afterClosed().pipe(take(1)).subscribe(appSaved => {
        if (appSaved) {
          this.getApplications(null);
        }
        if (this.yearChanged) {
          this.showYearChangeDialog(selectedYear);
        }
      });
    });

  }

  viewClick(app: FreeReducedMealApp) {
    this.freeReducedMealAppService.getFrmaAppWithPdf(app.ID).pipe(take(1)).subscribe(o => {
      const pdfName: string = moment.utc(o.SubmittedDate).format('MM-DD-YYYY') + '_Application';
      if (o.ApplicationAsPDF) {
        System.viewFileFromBase(o.ApplicationAsPDF, 'pdf', pdfName + '.pdf');
      }
    });
  }

  newAppClick() {
    this.showYearSelector(() => {
      if (this.studentLunchStatus && this.studentLunchStatus.students.find(o => !o.IsDirectCertification) != null) {
        const unsubmittedApp = this.getUnsubmittedApp();
        if (!unsubmittedApp) {
          // No unsubmitted application exists, open new application
          this.openNewApplication();
        }
        else {
        // need to check if household has changed
          this.freeReducedMealAppService.getFrmaApplication(unsubmittedApp.ID).pipe(take(1)).subscribe(a => {
            let selectedYear = this.years.find(o => o.Id == this.yearId);
            this.freeReducedMealAppService.getFRMAStudentsByFamilyId(selectedYear.Id, a.FamilyID).pipe(take(1)).subscribe(students => {
              this.studentService.getHouseholdParentsByFamilyID(a.FamilyID).pipe(take(1)).subscribe(parents => {
              const studentsChanged = this.freeReducedMealAppService.checkForStudentChange(a, students); // true if students were added or dropped since application started
              const parentsChanged = this.freeReducedMealAppService.checkForParentChange(a, parents); // true if parents were added or removed since application started
            if (studentsChanged === false && parentsChanged === false) {
              const unsubmittedDialog = this.dialog.open(FrmaUnsubmittedAppDialogComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: unsubmittedApp,
                width: '325px'
              });
              unsubmittedDialog.afterClosed().pipe(take(1)).subscribe((action: string) => {
                if (action == 'continue') {
                  this.editClick(unsubmittedApp);
                }
                else if (action == 'new') {
                  this.openNewApplication();
                }
                else {
                  if (this.yearChanged) {
                    selectedYear = this.years.find(o => o.Id == this.yearId);
                    this.showYearChangeDialog(selectedYear);
                  }
                }
              });
            }
            else {
              this.openNewApplication();
            }
         });
        });
      });
    }
    }
      else {
        this.showDirectCertDialog();
      }
    });
  }

  showYearSelector(_callback: Function) {
    if (this.years && this.years.length > 0) {
      const latestYearId = orderBy(this.years, ['StartDate'], ['desc'])[0].Id;
      if (this.yearId != latestYearId && this.years.filter(o => o.Status != 0).length > 1) {
        // we are not currently on the latest year and
        // there is more than 1 current or future year.  Need to show year selector.
        const yearDialog = this.dialog.open(FreeReducedMealAppYearSelectorComponent, {
          disableClose: true,
          data: {
            years: this.years
          }
        });

        yearDialog.afterClosed().pipe(take(1)).subscribe((selectedYear: Year) => {
          if (selectedYear) {
            if (selectedYear.Id != this.yearId) {
              this.yearChanged = true;
              this.yearId = selectedYear.Id;
              this.yearChange(_callback);
            }
            else if (_callback) {
              _callback();
            }
          }
        });
      }
      else {
        if (_callback) {
          _callback();
        }
      }
    }
  }

  deleteClick(app: FreeReducedMealApp) {
    const warningDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    this.translateService.get('Are you sure you want to delete the application started on {{1}}?').pipe(take(1)).subscribe((res: string) => {
      if (res) {
        warningDialog.componentInstance.confirmMessage = res.replace('{{1}}', formatDate(app.CreatedDate, 'MM/dd/yy', 'en-US'));
      }
    });
    this.translateService.get('Delete Application').pipe(take(1)).subscribe((res: string) => {
      if (res) {
        warningDialog.componentInstance.headerLabel = res;
      }
    });
    warningDialog.afterClosed().pipe(take(1)).subscribe((confirm) => {
      if (confirm) {
        this.freeReducedMealAppService.deleteFrmaApplication(app.ID).pipe(take(1)).subscribe(result => {
          if (result) {
            this.getApplications(null);
          }
          else {
            this.sharedService.showBadSnackbar();
          }
        });
      }
    });
  }

  yearChange(_callback: Function) {
    this.getFamilies(_callback);
    const selectedYear = this.years.find(o => o.Id == this.yearId);
      if (selectedYear && (selectedYear.Status == 1 || selectedYear.Status == 2)) {
        this.disableAdd = false; // current/future year
      }
      else {
        this.disableAdd = true; // past year
      }
  }

  openNewApplication() {
    const newApp = new FreeReducedMealApp(this.yearId, this.selectedFamily.FamilyID);
    const selectedYear = this.years.find(o => o.Id == this.yearId);
    const dialogRef = this.dialog.open(FreeReducedMealAppComponent, {
      height: '100vh',
      maxHeight: '100vh',
      width: '1000px',
      disableClose: true,
      data: {
        isDesignMode: false,
        singlePageMode: false,
        appData: newApp,
        selectedYear: selectedYear
      }
    });
    dialogRef.afterClosed().pipe(take(1)).subscribe(appSaved => {
      if (appSaved) {
        this.getApplications(null);
      }
      if (this.yearChanged) {
        this.showYearChangeDialog(selectedYear);
      }
    });
  }

  showDirectCertDialog() {
    const generalDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
      width: '360px',
    });
    generalDialog.componentInstance.informational = true;
    this.translateService.get('The students in your household are pre-qualified for free/reduced meals through state direct certification.<br /><br />You do not need to fill out this application.').pipe(take(1)).subscribe((res: string) => {
      if (res) {
        generalDialog.componentInstance.confirmMessage = res;
      }
    });
    this.translateService.get('No Need to Continue').pipe(take(1)).subscribe((res: string) => {
      if (res) {
        generalDialog.componentInstance.headerLabel = res;
      }
    });
  }

  getUnsubmittedApp(): FreeReducedMealApp {
    if (this.applications && this.applications.length > 0) {
      const lastApp = orderBy(this.applications, ['CreatedDate'], ['desc'])[0];
      if (lastApp.Status == 'not submitted') {
        return lastApp;
      }
    }
    return null;
  }

  showYearChangeDialog(year: Year) {
    this.yearChanged = false;
    const yearDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      width: '350px',
      disableClose: true,
    });
    let first = this.translateService.instant('You are now viewing data for {{1}}.');
    first = first.replace('{{1}}', year.Description);
    const second = this.translateService.instant('To change this, use the Academic Year dropdown located in the upper right corner of this page.');
    const header = this.translateService.instant('Academic Year Changed');

    yearDialog.componentInstance.headerLabel = header;
    yearDialog.componentInstance.confirmMessage = first;
    yearDialog.componentInstance.secondMessage = second;
    yearDialog.componentInstance.warning = true;
    yearDialog.componentInstance.informational = true;
  }

}
